import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported, type Analytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFunctions } from "firebase/functions";
import { shouldInitializeAppCheck } from "../utils/appCheck";

const firebaseConfig = {
  apiKey: "AIzaSyCdKkQARtvyaRhGJvza9V0EMUfOIDhs13c",
  authDomain: "chat.juris.es",
  projectId: "juris-856fb",
  storageBucket: "juris-856fb.firebasestorage.app",
  messagingSenderId: "684314486342",
  appId: "1:684314486342:web:8589e9398e4f62ff33cc47",
  measurementId: "G-X6CL0GCZNT"
};

const app = initializeApp(firebaseConfig);

const siteKey = import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY;
const appCheckHosts = import.meta.env.VITE_APPCHECK_ALLOWED_HOSTS;
if (siteKey && shouldInitializeAppCheck(window.location.hostname, appCheckHosts)) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(siteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else if (!siteKey && import.meta.env.DEV) {
  console.warn("App Check skip: VITE_RECAPTCHA_V3_SITE_KEY missing.");
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); // <--- EXPORTADO
export const cloudFunctions = getFunctions(app, 'europe-west1');

let analyticsPromise: Promise<Analytics | null> | null = null;

export const getAppAnalytics = (): Promise<Analytics | null> => {
  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((supported) => (supported ? getAnalytics(app) : null))
      .catch((error) => {
        if (import.meta.env.DEV) {
          console.warn("Google Analytics no disponible en este entorno.", error);
        }
        return null;
      });
  }

  return analyticsPromise;
};
